import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import classNames from 'classnames';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import { S3Image } from 'aws-amplify-react';
import SearchIcon from '@material-ui/icons/Search';
import PermContactCalendar from '@material-ui/icons/PermContactCalendar';
import styles from './contact-jss';
import Loader from '../Loader/Loader'; 
import defaultAvatar from '../../../static/images/avatars/default.png';

class ContactList extends React.Component {
  state = {
    filter: '',
  };

  //Input
  handleChange = (event) => {
    this.setState({ filter: event.target.value });
    this.props.search(event); 
  };

  //Clear filter 
  handleClear = () =>{
    this.setState({filter: ''}); 
    this.props.clearFilter(); 
  }

  addDefaultSrc(ev){
    ev.target.src = defaultAvatar;
  }
  
  render() {
    const {
      classes,
      dataContact,
      itemSelected,
      showDetail,
      clippedRight, 
      isLoading
    } = this.props;
    
    //const { filter } = this.state;
    const getItem = dataArray => dataArray.map(data => {
    
      //const index = dataContact.indexOf(data) ;
      if (data.id === -1) {
        return false;
      }
      return (
        <ListItem
          button
          key={`user_${data.id_usuario}`}
          className={data.id === itemSelected ? classes.selected : ''}
          onClick={() => showDetail(data)}
        >
          {/* isanchez 30.04.19 */}
          <Avatar 
            alt={data.name}
            src={ data.thumb[0]["40x40"] != undefined ? data.thumb[0]["40x40"] : "https://s3.amazonaws.com/portalacervo/resources/img/default-avatar.png"} 
            className={classNames(classes.avatar, classes.unsetFlex)} 
            onError={this.addDefaultSrc}
          >
          {
              !data.thumb[0]["40x40"] ? <S3Image theme={{ photoImg: { width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' } }} imgKey={data.avatar} /> : ""
          }
          </Avatar>
          

          <ListItemText primary={`${data.nombre} `} secondary={data.unidad_negocio ? data.unidad_negocio : "-"} />
        </ListItem>
      );
    
    });

    return (
      <Fragment>
        <Drawer
          variant="permanent"
          anchor="left"
          open
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div>
            <div className={classNames(classes.toolbar, clippedRight && classes.clippedRight)}>
              <div className={classes.flex}>
                <div className={classes.searchWrapper}>
                  <div className={classes.search}>
                    <SearchIcon />
                  </div>
                  <input className={classes.input} value={this.state.filter} onChange={this.handleChange} placeholder="Buscar usuario" disabled={isLoading}/>
                </div>
              </div>
            </div>
            <Divider />
            <List>
              {
                isLoading ? 
                <Loader text="" /> :
                getItem(dataContact)}
            </List>
          </div>
        </Drawer>
        <div className={classes.bottomIcon} onClick={this.handleClear}>
          <PermContactCalendar className={classes.iconBlock}/>
          <small>Todos</small>
        </div>
      </Fragment>
    );
  }
}

ContactList.propTypes = {
  classes: PropTypes.object ,
  dataContact: PropTypes.array,
  keyword: PropTypes.string ,
  itemSelected: PropTypes.number,
  showDetail: PropTypes.func,
  search: PropTypes.func,
  clippedRight: PropTypes.bool,
  isLoading: PropTypes.bool, 
  clearFilter: PropTypes.func
};

ContactList.defaultProps = {
  clippedRight: false, 
  isLoading: false, 
  clearFilter: () => {}
};

export default withStyles(styles)(ContactList);
